import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
import { Emission } from "./emissions";

const structure = apiUrl + "/structure";
const routes = {
  label: "Structure",
  root: structure,
  new: structure + "/new",
  delete: structure + "/delete",
  update: structure + "/update",
  duplicate: structure + "/duplicate",
  archive: structure + "/archive",
  unarchive: structure + "/unarchive",
  get_mine: structure + "/get_mine",
  get_from_my_workspace: structure + "/get_from_my_workspace",
  get_total_gwp_by_scope: structure + "/get_total_gwp_by_scope",
  generate_insight_5_0: structure + "/generate_insight_5_0",
  generate_insight_3_5: structure + "/generate_insight_3_5",
  generate_insight_deepseek: structure + "/generate_insight_deepseek",
  generate_insight_gemini_flash: structure + "/generate_insight_gemini_flash",
  generate_insight_gemini_flash_lite: structure + "/generate_insight_gemini_flash_lite",
  generate_insight_gemini_pro: structure + "/generate_insight_gemini_pro",
  get_insight: structure + "/get_insight",
  get_actionable_insight: structure + "/get_actionable_insight",
  generate_actionable_insight: structure + "/generate_actionable_insight",
};

export const Structure = {
  label: routes.label,
  new: (data) => postWithToken(routes.new, data),
  update: (structures) => postWithToken(routes.update, structures),
  duplicate: (ids) => postWithToken(routes.duplicate, { ids }),
  archive: (ids) => postWithToken(routes.archive, { ids }),
  unarchive: (ids) => postWithToken(routes.unarchive, { ids }),
  delete: (ids) => postWithToken(routes.delete, { ids }),
  get_mine: () => getWithToken(routes.get_mine),
  get_from_my_workspace: () => getWithToken(routes.get_from_my_workspace),
  getEmissions: (id) => Emission.getEmissionsByStructureId(id),
  get_total_gwp_by_scope: (ids) => getWithToken(routes.get_total_gwp_by_scope, { ids }),
  generate_insight_5_0: (id) => postWithToken(routes.generate_insight_5_0, { id }),
  generate_insight_3_5: (id) => postWithToken(routes.generate_insight_3_5, { id }),
  generate_insight_deepseek: (id) => postWithToken(routes.generate_insight_deepseek, { id }),
  generate_insight_gemini_flash: (id) => postWithToken(routes.generate_insight_gemini_flash, { id }),
  generate_insight_gemini_flash_lite: (id) => postWithToken(routes.generate_insight_gemini_flash_lite, { id }),
  generate_insight_gemini_pro: (id) => postWithToken(routes.generate_insight_gemini_pro, { id }),
  get_insight: (id) => getWithToken(routes.get_insight, { id }),
  get_actionable_insight: (id) => getWithToken(routes.get_actionable_insight, { id }),
  generate_actionable_insight: (id) => postWithToken(routes.generate_actionable_insight, { id }),
  request_validation: (ids) => postWithToken(structure + "/request_validation", { ids }),
  set_validation_status: (payload) => postWithToken(structure + "/set_validation_status", payload),
  retrieve: (ids) => postWithToken(structure + "/retrieve", { ids }),
};

